import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { addNotification } from 'actions/NotificationsActions';
import List from 'components/List';
import ClientListInfo from 'components/layout/ClientListInfo';
import Loader from 'components/layout/Loader';
import { findIndex as _findIndex } from 'lodash';
import IntlDate from 'components/layout/IntlDate';

class CouponUsage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noStateDefined: null,
    };
  }

  componentDidUpdate = prevProps => {};

  render() {
    const {
      intl: { messages },
      list,
      entity,
    } = this.props;

    const columns = [messages.company, messages.user, messages.date, messages.order, messages.amount];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const order = list.data.list[i];
      const { target } = order;
      const { creator } = order;
      const orderId = order.id;
      const couponIndex = _findIndex(order.coupons, o => o.coupon.id === entity.getId());

      tBody.push(
        <tr key={i}>
          <td className="v-align-middle">
            <ClientListInfo client={target} />
          </td>
          <td className="v-align-middle">
            <ClientListInfo client={creator} />
          </td>
          <td className="v-align-middle">{<IntlDate date={order.cdate} />}</td>
          <td className="v-align-middle">ID: {orderId}</td>
          <td className="v-align-middle">
            {<FormattedNumber value={order.coupons[couponIndex].value} style="currency" currency={order.currency} />}
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <>
        <List
          listName="couponUsages"
          url={`/api/coupondefinitions/${entity.getId()}/usage.json`}
          // urlData={{ filters: { type: 'customer' } }}
          list={list}
          title={messages.coupon_usage}
          iconClass="fa-regular fa-money-bill"
          sortOptions={['name,asc', 'cdate,desc', 'mdate,desc']}
        >
          {resultTable}
        </List>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    list: state.list.couponUsages,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CouponUsage)
);
